import { computed, ref, watch, useCssModule } from "vue";
import { g as getUid } from "./assets/index-Df_FM1j-.js";
import { u as useI18n } from "./assets/index-CgZzOVq6.js";
import "vue-demi";
import { u as useDataTestIdProp } from "./assets/index-BNd8MWnO.js";
import { u as useDisabledProp } from "./assets/index-DKxr0Yto.js";
import { u as useElevationProp } from "./assets/index-hC42R8vZ.js";
import { X as XIcon, u as useIconProps } from "./assets/XIcon-U9bwokTN.js";
import "./assets/index-vzP2cezV.js";
import "vue-router";
import "dompurify";
import "@vueuse/core";
import XEllipsis from "./XEllipsis.js";
import { n as normalizeComponent } from "./assets/_plugin-vue2_normalizer-VvYS6rEj.js";
import "vue-i18n";
import "./locales.js";
import "@fortawesome/vue-fontawesome";
const { t } = useI18n();
const PADDING_OPTIONS = ["small", "regular", "medium"];
const TITLE_SIZE_OPTIONS = ["regular", "medium"];
const PADDING_VARIABLES = {
  small: "var(--space-small-x)",
  regular: "var(--space-regular)",
  medium: "var(--space-medium)"
};
const FONT_FAMILY_VARIABLES = {
  regular: "var(--font-family-body)",
  medium: "var(--font-family-title)"
};
const FONT_SIZE_VARIABLES = {
  regular: "var(--font-size-regular)",
  medium: "var(--font-size-medium)"
};
const FONT_WEIGHT_VARIABLES = {
  regular: "var(--font-weight-regular)",
  medium: "var(--font-weight-semibold)"
};
const BUTTON_ALT_TEXTS = {
  close: t("ds.xCollapse.actions.close"),
  open: t("ds.xCollapse.actions.open")
};
const xCollapse = "_xCollapse_14p2s_1";
const button = "_button_14p2s_19";
const label = "_label_14p2s_30";
const isDisabled = "_isDisabled_14p2s_52";
const buttonContent = "_buttonContent_14p2s_60";
const iconTitle = "_iconTitle_14p2s_67";
const buttonText = "_buttonText_14p2s_71";
const buttonIcon = "_buttonIcon_14p2s_78";
const content = "_content_14p2s_81";
const isOpen = "_isOpen_14p2s_104";
const style0 = {
  xCollapse,
  button,
  label,
  isDisabled,
  buttonContent,
  iconTitle,
  buttonText,
  buttonIcon,
  content,
  isOpen
};
const { createIconProps } = useIconProps();
const { createElevationProp, getElevationBoxShadow } = useElevationProp();
const { createDisabledProp, getDisabledClass } = useDisabledProp();
const { createTestIdProp, setupTestId } = useDataTestIdProp();
const __default__ = {
  name: "XCollapse",
  components: {
    XIcon,
    XEllipsis
  }
};
const _sfc_main = /* @__PURE__ */ Object.assign(__default__, {
  props: {
    title: {
      type: String,
      required: true
    },
    isOpen: {
      type: Boolean,
      default: false
    },
    titleSize: {
      type: String,
      default: "regular",
      validator: (size) => TITLE_SIZE_OPTIONS.includes(size)
    },
    padding: {
      type: String,
      default: "regular",
      validator: (padding) => PADDING_OPTIONS.includes(padding)
    },
    border: {
      type: Boolean,
      default: true
    },
    ...createElevationProp(),
    ...createIconProps(),
    ...createDisabledProp(),
    ...createTestIdProp()
  },
  emits: ["open", "close"],
  setup(__props, { emit }) {
    const props = __props;
    const { formatTestId } = setupTestId(props);
    function useControl() {
      const labelId2 = getUid("label");
      const contentId2 = getUid("content");
      const isOpenInternal2 = ref(props.isOpen);
      function toggleCollapse2() {
        if (!props.disabled) {
          isOpenInternal2.value = !isOpenInternal2.value;
          emit(isOpenInternal2.value ? "open" : "close");
        }
      }
      watch(
        () => props.isOpen,
        () => {
          toggleCollapse2();
        }
      );
      return {
        isOpenInternal: isOpenInternal2,
        labelId: labelId2,
        contentId: contentId2,
        toggleCollapse: toggleCollapse2
      };
    }
    const { isOpenInternal, labelId, contentId, toggleCollapse } = useControl();
    const buttonAltText = computed(() => {
      return isOpenInternal.value ? BUTTON_ALT_TEXTS.close : BUTTON_ALT_TEXTS.open;
    });
    function useStyles() {
      const $style = useCssModule();
      const { disabledClass } = getDisabledClass(props);
      const { boxShadow } = getElevationBoxShadow(props);
      const collapseStyles2 = computed(() => ({
        "--xCollapse-font-size": FONT_SIZE_VARIABLES[props.titleSize],
        "--xCollapse-font-weight": FONT_WEIGHT_VARIABLES[props.titleSize],
        "--xCollapse-font-family": FONT_FAMILY_VARIABLES[props.titleSize],
        "--xCollapse-space": PADDING_VARIABLES[props.padding],
        "--xCollapse-border-color": props.border ? "var(--color-neutral-600)" : "transparent",
        ...boxShadow.value
      }));
      const collapseClasses2 = computed(() => ({
        [$style.isOpen]: isOpenInternal.value,
        ...disabledClass.value
      }));
      return {
        collapseStyles: collapseStyles2,
        collapseClasses: collapseClasses2
      };
    }
    const { collapseStyles, collapseClasses } = useStyles();
    return { __sfc: true, createIconProps, createElevationProp, getElevationBoxShadow, createDisabledProp, getDisabledClass, createTestIdProp, setupTestId, props, emit, formatTestId, useControl, isOpenInternal, labelId, contentId, toggleCollapse, buttonAltText, useStyles, collapseStyles, collapseClasses, XIcon, XEllipsis };
  }
});
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c("div", { class: [_vm.$style.xCollapse, _setup.collapseClasses], style: _setup.collapseStyles, attrs: { "data-testid": _setup.formatTestId() } }, [_c("h4", { class: _vm.$style.label, attrs: { "id": _setup.labelId } }, [_c("button", { class: _vm.$style.button, attrs: { "aria-controls": _setup.contentId, "aria-expanded": _setup.isOpenInternal, "aria-disabled": _vm.disabled, "title": _setup.buttonAltText, "data-testid": _setup.formatTestId("button"), "type": "button" }, on: { "click": function($event) {
    return _setup.toggleCollapse();
  } } }, [_c("div", { class: _vm.$style.buttonContent }, [_vm.icon ? _c(_setup.XIcon, { class: _vm.$style.iconTitle, attrs: { "icon": _vm.icon, "icon-style": _vm.iconStyle, "data-testid": _setup.formatTestId("iconTitle"), "left": "" } }) : _vm._e(), _c(_setup.XEllipsis, { class: _vm.$style.buttonText, attrs: { "visible-lines": 2 } }, [_vm._v(" " + _vm._s(_vm.title) + " ")])], 1), _c(_setup.XIcon, { class: _vm.$style.buttonIcon, attrs: { "icon": _setup.isOpenInternal ? "chevron-up" : "chevron-down", "data-testid": _setup.formatTestId("iconChevron") } })], 1)]), _c("section", { directives: [{ name: "show", rawName: "v-show", value: _setup.isOpenInternal, expression: "isOpenInternal" }], class: _vm.$style.content, attrs: { "id": _setup.contentId, "aria-labelledby": _setup.labelId, "data-testid": _setup.formatTestId("content") } }, [_vm._t("default")], 2)]);
};
var _sfc_staticRenderFns = [];
const __cssModules = {
  "$style": style0
};
function _sfc_injectStyles(ctx) {
  for (var key in __cssModules) {
    this[key] = __cssModules[key];
  }
}
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  _sfc_injectStyles
);
const XCollapse = __component__.exports;
export {
  XCollapse as default
};
